import $ from 'jquery';
import {isPhone} from '../useragent';
import Watcher from '../watcher';

// FAQs / Service Items in mobil zum Aufklappen:
if (isPhone) {
    $('.faq-section > div').addClass('accordion-expand');
}
import accordionExpand from '../parts/accordion-expand';
accordionExpand();

const watcher = new Watcher();

// Intro Effekte triggern:
setTimeout(() => {
    $('#intro .emerge').addClass('emerge-show');
}, 100);

$('.faq-section .emerge.words').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            $(ele).addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});
